import { useEffect, useState } from 'react';
import {
  BrandResponse,
  getSoldUnsoldProductsByVendor
} from 'api/dashboard/_request';
import { Card } from 'react-bootstrap';
import EcomTopBrandChart from 'components/charts/e-charts/EcomTopBrandChart';
import { useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';

const EcomTopBrandCard = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const id = user?._id;
  const [productsoldunsold, setProductsoldunsold] = useState<BrandResponse>();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getSoldUnsoldProductsByVendor(id);
        setProductsoldunsold(response);
      } catch (error) {
        console.error('Failed to fetch brand data', error);
      }
    };

    fetchData();
  }, []);

  return (
    <Card className="h-100">
      <Card.Body className="d-flex flex-column justify-content-between">
        <div className="mb-3">
          <h5 className="mb-1 fs-6">Product Sold vs Unsold</h5>
          <h6 className="text-body-tertiary fs-sm">
            Overview of Sold and Unsold Products
          </h6>
          <h4 className="fw-semibold">
            {productsoldunsold?.totalProducts ?? 0}
          </h4>
        </div>

        <div className="flex-grow-1 d-flex flex-column justify-content-center">
          {productsoldunsold && (
            <>
              <div className="d-flex justify-content-center">
                <EcomTopBrandChart summary={productsoldunsold} />
              </div>

              <div className="d-flex justify-content-around mt-3 text-center">
                <div>
                  <h6 className="mb-1 fs-sm">Sold</h6>
                  <span className="fw-bold text-primary">
                    {productsoldunsold.soldProducts ?? 0}
                  </span>
                </div>
                <div>
                  <h6 className="mb-1 fs-sm">Unsold</h6>
                  <span className="fw-bold text-secondary">
                    {productsoldunsold.unsoldProducts ?? 0}
                  </span>
                </div>
              </div>
            </>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default EcomTopBrandCard;
